// Copyright (c) 2016 Deere & Company

import {resetMachineStatusHistoryToDisplay, updateMachineStatusHistoryToDisplay} from './criteria';
import {createMachineStatusHistoryReport} from './create-report';
import {sharedActionCreators} from '../../shared/action-creators';

export default {
    createMachineStatusHistoryReport,
    resetMachineStatusHistoryToDisplay,
    updateMachineStatusHistoryToDisplay,
    ...sharedActionCreators
};



// WEBPACK FOOTER //
// ./src/reports/update-machine-status-history/action-creators/index.js